import React, { useState } from 'react';
import './Footer.css';

function ContactUs() {
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, you would send this to your backend
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormState({ name: '', email: '', message: '' });
  };

  return (
    <section className="footer-section contact-section" id="contact">
      <div className="section-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      </div>
      <h2 className="section-title">Get in Touch</h2>
      <p className="section-description">
        Have questions, feedback, or want to suggest a public figure to add?
        We'd love to hear from you.
      </p>

      {submitted ? (
        <div className="success-message">
          <span className="success-icon">✓</span>
          <span>Thank you! We'll get back to you soon.</span>
        </div>
      ) : (
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="contact-name">Name</label>
              <input
                type="text"
                id="contact-name"
                name="name"
                value={formState.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="contact-email">Email</label>
              <input
                type="email"
                id="contact-email"
                name="email"
                value={formState.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              value={formState.message}
              onChange={handleChange}
              placeholder="What would you like to tell us?"
              rows="4"
              required
            />
          </div>
          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>
      )}

      <div className="contact-links">
        <a href="mailto:contact@karmaranking.com" className="contact-link">
          <span className="link-icon">✉️</span>
          contact@karmaranking.com
        </a>
      </div>
    </section>
  );
}

export default ContactUs;
